module.exports = __webpack_public_path__ + "static/media/loading15.52120885.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading15.png
// module id = 200
// module chunks = 0